import { useEffect, useState } from "react";
import ConsultantHeader from "./Header/ConsultantHeader";
import NavigationDrawer from "./Drawer/Drawer";
// Import other pages

function ConsultantHeaderAndDrawer() {
  //This is the state of the drawer
  const [isOpen, setIsOpen] = useState(false);
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsOpen(open);
  };

  //------------------------------------------Width Stuff

  const [screenWidth, setscreenWidth] = useState(
    window.innerWidth <= 1200 ? "Small" : "Big"
  );

  useEffect(() => {
    const handleResize = () => {
      setscreenWidth(window.innerWidth <= 1200 ? "Small" : "Big");
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <ConsultantHeader
        isOpen={isOpen}
        toggleDrawer={toggleDrawer}
        screenWidth={screenWidth}
      />
      <NavigationDrawer
        isOpen={isOpen}
        toggleDrawer={toggleDrawer}
        setIsOpen={setIsOpen}
        screenWidth={screenWidth}
      />
    </>
  );
}

export default ConsultantHeaderAndDrawer;
